export const SIDEBAR_OPEN = "SIDEBAR_OPEN";
export const MAIN_PLAYER_TOGGLE = "MAIN_PLAYER_TOGGLE";
export const VOLUME_TOGGLE = "VOLUME_TOGGLE";
export const NOTIFICATION = "NOTIFICATION";
